import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const ProtectedRoute: React.FC = () => {
  const { basicData, token, loading } = useUserContext();
  const location = useLocation();

  const isAuthenticated = Boolean(basicData && token);
  // console.log("IS AUTHENTICATED?:", isAuthenticated);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
  return (
  <Navigate
  to="/"
  replace
  state={{ from: location }}
  />
  );
  }

  return <Outlet />;
};

export default ProtectedRoute;